export default (props) => (
  /**
   * Ícone ponto na listagem de classes da classificação por atributo
   * quando camada é do tipo ponto.
   * Cor parametrizada.   
   */  
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={7.9375}
      cy={7.375}
      r={7}
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
